import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  categoryBox: {
    margin: theme.spacing(1),
    borderRadius: 4,
    boxShadow: theme.shadows[1],
    minHeight: 64,
  },
  icon: {
    marginTop: theme.spacing(0.5),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  assignment: {
    paddingRight: theme.spacing(1),
  },
}));

export default useStyles;
